export type MarketingTestimonial = {
  id: string;
  quote: string;
  author: string;
  handle?: string;
};

/** Depoimentos espelhados da home constelabrasil.com.br (texto + prints do Instagram). */
export const MARKETING_TESTIMONIALS: MarketingTestimonial[] = [
  {
    id: "mariana-oliveira",
    author: "Mariana Oliveira",
    quote:
      "A experiência de constelação online foi transformadora! A profundidade e segurança me surpreenderam. Recomendo a todos que buscam autoconhecimento.",
  },
  {
    id: "ramosdulcinea",
    author: "Dulcinea Ramos",
    handle: "@ramosdulcinea",
    quote:
      "Adorei essa constelação, pois esclareceu muitos pontos da minha relação com meu filho, que estavam travados, e eu não entendia os porquês dos problemas. A constelação foi muito esclarecedora para eu enxergar os pontos negativos, para poderem ser trabalhados e resolver os problemas. Foi gratificante. Só tenho que agradecer as pessoas envolvidas nessa constelação. Gratidão!",
  },
  {
    id: "marcemarassa",
    author: "Marce Marassa",
    handle: "@marcemarassa",
    quote:
      "Conheci a Érica em Santos, comecei a frequentar os encontros das constelações como participante, fui constelado, tudo presencial e foi incrível! Agora que não estou mais em Santos, passei a participar das constelações pela plataforma, fui constelado também através da plataforma e foi realmente incrível! A emoção, os sentimentos, são exatamente como acontece presencial! Só tenho que agradecer, porque senti muita falta de participar, e tem sido muito gratificante!",
  },
  {
    id: "dresantosmentora",
    author: "Dres Santos Mentora",
    handle: "@dresantosmentora",
    quote:
      "Tive o prazer de participar de um processo de constelação com a ferramenta, e eu adorei. Como consulente achei fácil de manusear e de participar. Parabéns, ideia extraordinária!",
  },
  {
    id: "ericapriscila",
    author: "Érica Priscila Andrade",
    handle: "@andrade.ericapriscila",
    quote:
      "Gratidão define minha jornada aqui! Ser constelada nessa plataforma foi uma experiência emocionante e reveladora. É lindo ver como a Érica usou o digital para aproximar tantos corações da cura. Participo sempre e recomendo de olhos fechados para quem deseja dar um passo novo na vida. É transformador!",
  },
  {
    id: "jenifferplenus",
    author: "Jeniffer Plenus",
    handle: "@jenifferplenus",
    quote:
      "A plataforma @constelabrasiloficial veio para trazer tecnologia para o autoconhecimento e aproximar pessoas de diversos lugares em prol de uma constelação em grupo. Se você não está na minha cidade, não tem problema: ainda pode fazer a sua constelação com pessoas em grupo, se assim preferir!",
  },
];
